// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.renderedSong {
  padding: var(--page-padding);
  animation: fadein 200ms;
  /**
   * The end padding was being applied inconsistantly between browsers
   * See .renderedSongEndPadding
   */
  padding-bottom: 0;
  margin: 0 auto;
  font-size: var(--font-size-editor);
  font-family: 'Roboto Mono', monospace;
}

@media (max-width: 500px) {
  .renderedSong {
    padding: 10px;
  }
}

.viewFileSplit .renderedSong {
  box-shadow: -20px 0 20px #00000012;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

/* In the split editor the rendered chart is a rounded card that scrolls
   internally, matching the source card beside it. */
.splitterSplit .renderedSong {
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px #0000000d;
  padding: 40px 44px 0;
}

.splitterSplit .renderedSongStickyHeader {
  top: 12px;
}

.splitterSplit .renderedSongStickyHeaderRow {
  border: 1px solid var(--line);
}

.renderedSongHeader {
  display: flex;
  /* Leave space for the sticky header */
  margin-inline-end: 70px;
}

.renderedSongHeaderTitle {
  flex: 1;
}

.renderedSongHeaderTitle h1, .renderedSongHeaderTitle h2 {
  margin: 0;
  margin-bottom: 6px;
}

.renderedSongHeaderTitle h1 {
  font-size: 1.7em;
  display: flex;
  align-items: center;
}

.renderedSongHeaderTitleSpan {
  flex: 1;
}

.renderedSongHeaderTitle h2 {
  font-size: 1.2em;
  color: var(--text-border);
}

.renderedSongLine {
  position: relative; /* create a stacking context for the chords. */
}

.renderedSongSpace {
  height: 1.5em;
}

.renderedSongComment {
  font-weight: bold;
  color: #666;
  margin: 4px 0;
}

.renderedSongItalic {
  font-style: italic;
}

.renderedSongLine-chords {
  margin: 3px 0;
}

.renderedSongLine-mixed {
  padding-top: 0;
  max-width: 100%;
  line-height: 2.7;
  position: relative;
  top: 0.5em;
}

.renderedSongLine-mixed .renderedSongLineChord {
  position: relative;
  top: -17px;
  width: 0;
  display: inline-block;
  white-space: nowrap;
}

.renderedSongLineChordExtras {
  font-weight: normal;
}

.renderedSongLineChordText {
  & sup {
    padding-inline-start: 1px;
    font-weight: normal;
  }
}

.renderedSongLine-chords .renderedSongLineChord {
  /* Maybe restore this, spacing was weird. */
  /* margin-inline-end: 5px;
  min-width: 35px; */
  display: inline-block;
}

.renderedSongLineChord {
  font-weight: bold;
}

.renderedSongSection {
  color: #666;
  margin: 1.2em 0;
}

.renderedSongLineText {
  white-space: pre-wrap;
}

.renderedSongStickyHeader {
  margin-left: 15px;
  text-align: right;
  position: sticky;
  top: var(--header-padding);
  height: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1;
}

.renderedSongStickyHeaderRow {
  background: #fff;
  padding: 7px;
  padding-inline-end: 0;
  border-radius: 5px;
}

.renderedSongEndPadding {
  height: var(--page-padding);
}

.renderedSongEdit {
  background-color: #eee;
  border: 1px solid var(--button-border);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: var(--font-size-editor);
}

a.renderedSongHeaderSpotify {
  margin-inline: 1em;
  background-color: #1ed760;
  padding: 0.3em 0.5em 0.2em;
  border-color: #138e3f;
}

@media print {
  a.renderedSongHeaderSpotify {
     display: none;
  }
}


@media (min-width: 900px) {
  .viewChoproSolo .renderedSong {
    min-width: 800px;
    max-width: var(--page-max-width);
  }
}

@media all and (display-mode: fullscreen) {
  .renderedSong,
  .viewChoproSolo .renderedSong {
    /* The full screen div is always full width. Use padding for centering. */
    --padding: calc(
      max(
        (100vw - var(--page-max-width)) / 2,
        20px
      )
    );
    padding-left: var(--padding);
    padding-right: var(--padding);
    max-width: 100%;
  }
}

@media print {
  .renderedSongStickyHeader {
     display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/RenderedSong.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB;;;IAGE;EACF,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;oDACoD;AACpD;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,2CAA2C;EAC3C;oBACkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE;KACG,aAAa;EAChB;AACF;;;AAGA;EACE;IACE,gBAAgB;IAChB,gCAAgC;EAClC;AACF;;AAEA;EACE;;IAEE,yEAAyE;IACzE;;;;;KAKC;IACD,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;EACjB;AACF;;AAEA;EACE;KACG,aAAa;EAChB;AACF","sourcesContent":[".renderedSong {\n  padding: var(--page-padding);\n  animation: fadein 200ms;\n  /**\n   * The end padding was being applied inconsistantly between browsers\n   * See .renderedSongEndPadding\n   */\n  padding-bottom: 0;\n  margin: 0 auto;\n  font-size: var(--font-size-editor);\n  font-family: 'Roboto Mono', monospace;\n}\n\n@media (max-width: 500px) {\n  .renderedSong {\n    padding: 10px;\n  }\n}\n\n.viewFileSplit .renderedSong {\n  box-shadow: -20px 0 20px #00000012;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* In the split editor the rendered chart is a rounded card that scrolls\n   internally, matching the source card beside it. */\n.splitterSplit .renderedSong {\n  box-sizing: border-box;\n  height: 100%;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 3px #0000000d;\n  padding: 40px 44px 0;\n}\n\n.splitterSplit .renderedSongStickyHeader {\n  top: 12px;\n}\n\n.splitterSplit .renderedSongStickyHeaderRow {\n  border: 1px solid var(--line);\n}\n\n.renderedSongHeader {\n  display: flex;\n  /* Leave space for the sticky header */\n  margin-inline-end: 70px;\n}\n\n.renderedSongHeaderTitle {\n  flex: 1;\n}\n\n.renderedSongHeaderTitle h1, .renderedSongHeaderTitle h2 {\n  margin: 0;\n  margin-bottom: 6px;\n}\n\n.renderedSongHeaderTitle h1 {\n  font-size: 1.7em;\n  display: flex;\n  align-items: center;\n}\n\n.renderedSongHeaderTitleSpan {\n  flex: 1;\n}\n\n.renderedSongHeaderTitle h2 {\n  font-size: 1.2em;\n  color: var(--text-border);\n}\n\n.renderedSongLine {\n  position: relative; /* create a stacking context for the chords. */\n}\n\n.renderedSongSpace {\n  height: 1.5em;\n}\n\n.renderedSongComment {\n  font-weight: bold;\n  color: #666;\n  margin: 4px 0;\n}\n\n.renderedSongItalic {\n  font-style: italic;\n}\n\n.renderedSongLine-chords {\n  margin: 3px 0;\n}\n\n.renderedSongLine-mixed {\n  padding-top: 0;\n  max-width: 100%;\n  line-height: 2.7;\n  position: relative;\n  top: 0.5em;\n}\n\n.renderedSongLine-mixed .renderedSongLineChord {\n  position: relative;\n  top: -17px;\n  width: 0;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.renderedSongLineChordExtras {\n  font-weight: normal;\n}\n\n.renderedSongLineChordText {\n  & sup {\n    padding-inline-start: 1px;\n    font-weight: normal;\n  }\n}\n\n.renderedSongLine-chords .renderedSongLineChord {\n  /* Maybe restore this, spacing was weird. */\n  /* margin-inline-end: 5px;\n  min-width: 35px; */\n  display: inline-block;\n}\n\n.renderedSongLineChord {\n  font-weight: bold;\n}\n\n.renderedSongSection {\n  color: #666;\n  margin: 1.2em 0;\n}\n\n.renderedSongLineText {\n  white-space: pre-wrap;\n}\n\n.renderedSongStickyHeader {\n  margin-left: 15px;\n  text-align: right;\n  position: sticky;\n  top: var(--header-padding);\n  height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  z-index: 1;\n}\n\n.renderedSongStickyHeaderRow {\n  background: #fff;\n  padding: 7px;\n  padding-inline-end: 0;\n  border-radius: 5px;\n}\n\n.renderedSongEndPadding {\n  height: var(--page-padding);\n}\n\n.renderedSongEdit {\n  background-color: #eee;\n  border: 1px solid var(--button-border);\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-size: var(--font-size-editor);\n}\n\na.renderedSongHeaderSpotify {\n  margin-inline: 1em;\n  background-color: #1ed760;\n  padding: 0.3em 0.5em 0.2em;\n  border-color: #138e3f;\n}\n\n@media print {\n  a.renderedSongHeaderSpotify {\n     display: none;\n  }\n}\n\n\n@media (min-width: 900px) {\n  .viewChoproSolo .renderedSong {\n    min-width: 800px;\n    max-width: var(--page-max-width);\n  }\n}\n\n@media all and (display-mode: fullscreen) {\n  .renderedSong,\n  .viewChoproSolo .renderedSong {\n    /* The full screen div is always full width. Use padding for centering. */\n    --padding: calc(\n      max(\n        (100vw - var(--page-max-width)) / 2,\n        20px\n      )\n    );\n    padding-left: var(--padding);\n    padding-right: var(--padding);\n    max-width: 100%;\n  }\n}\n\n@media print {\n  .renderedSongStickyHeader {\n     display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
